(function () {
var BADGE_CLS     = 'cart-gw-badge';
var OFFER_CLS     = 'alo-gw-offer';
var GW_VARIANT_ID = 46830378647769;
var GN_VARIANT_ID = 48729248432345;
var _lastGwItemKeys = {};
var GW_IMAGE_URL  = 'https://cdn.shopify.com/s/files/1/0603/0367/1513/files/aloraagift-wrapping-8513690.jpg?v=1776694092';
function _gwGuardEvent(e) {
var t = e.target;
if (!t) return;
var cls = (typeof t.className === 'string' ? t.className : '');
if (cls.indexOf(OFFER_CLS + '__btn') !== -1 || cls.indexOf(BADGE_CLS) !== -1) {
console.log('[ALORAA GW] guard fired:', e.type, cls);
}
}
document.addEventListener('click',     _gwGuardEvent, true);
document.addEventListener('mousedown', _gwGuardEvent, true);
var style = document.createElement('style');
style.textContent = [
'.' + BADGE_CLS + ' {',
'  display: inline-flex !important; width: auto !important; max-width: none !important;',
'  flex-wrap: nowrap; white-space: nowrap;',
'  align-items: center; gap: 5px; margin: 3px 0 2px;',
'  font-size: 12px; color: #6b4f35; background: #f5ede5;',
'  border: 1px solid #e0cfc4; border-radius: 4px; padding: 2px 8px;',
'  font-weight: 500; letter-spacing: 0.01em; line-height: 1.4;',
'}',
'.' + OFFER_CLS + ' {',
'  display: flex; align-items: center; gap: 8px; margin: 6px 0 2px;',
'  padding: 8px 10px; background: #faf8f6;',
'  border: 1.5px solid #e4dfd9; border-radius: 6px;',
'  font-size: 12px; color: #3d2f27; line-height: 1.4;',
'}',
'.' + OFFER_CLS + '__text { flex: 1; }',
'.' + OFFER_CLS + '__btn {',
'  flex-shrink: 0; background: #8b6a4f; color: #fff; border: none;',
'  border-radius: 4px; padding: 5px 12px; font-size: 12px; font-weight: 600;',
'  cursor: pointer; white-space: nowrap; transition: opacity 0.15s ease;',
'}',
'.' + OFFER_CLS + '__btn:disabled { opacity: 0.55; cursor: default; }',
'.' + OFFER_CLS + '--added { background: #f0f7f0; border-color: #c4ddc4; color: #2e5a2e; }',
'[data-gw-inline] {',
'  display: flex !important; align-items: center; gap: 8px;',
'  padding: 6px 0 6px 12px; margin: -2px 0 8px;',
'  border-left: 2px solid #e0cfc4; background: #faf8f6;',
'  font-size: 12px; color: #6b4f35; line-height: 1.4; box-sizing: border-box;',
'}'
].join('\n');
document.head.appendChild(style);
function isInCartContext(el) {
var node = el;
for (var depth = 0; depth < 12; depth++) {
if (!node || node === document.body) break;
var cls = (typeof node.className === 'string' ? node.className : '') + ' ' + (node.id || '');
if (cls.indexOf('cart') !== -1 || cls.indexOf('qikify') !== -1 ||
cls.indexOf('drawer') !== -1 || cls.indexOf('mini-cart') !== -1 ||
cls.indexOf('sidebar') !== -1) {
return true;
}
node = node.parentElement;
}
return false;
}
function nearestRow(el) {
try {
return el.closest('li, tr, [class*="cart-item"], [class*="item"], [class*="product-row"]') || el.parentElement;
} catch (e) { return el.parentElement; }
}
function isGwRow(row) {
if (!row) return false;
try {
var txt = (row.textContent || '').toLowerCase();
return txt.indexOf('wrapping for') !== -1 || txt.indexOf('gift wrapping') !== -1;
} catch (e) { return false; }
}
function titleMatches(nodeText, titleStr) {
try {
var n = nodeText.toLowerCase().trim();
var titleLower = titleStr.toLowerCase().trim();
if (!n || !titleLower || n.length < 4) return false;
if (n === titleLower) return true;
var nodeHasDash  = n.indexOf(' - ') !== -1;
var titleHasDash = titleLower.indexOf(' - ') !== -1;
var baseNode  = nodeHasDash  ? n.split(' - ')[0].trim() : n;
var baseTitle = titleHasDash ? titleLower.split(' - ')[0].trim() : titleLower;
if (!nodeHasDash || !titleHasDash) {
if (baseNode === baseTitle) return true;
if (n === baseTitle || baseNode === titleLower) return true;
}
return false;
} catch (e) { return false; }
}
function xhrPost(url, body, onDone, onFail) {
try {
var xhr = new XMLHttpRequest();
xhr.open('POST', url, true);
xhr.setRequestHeader('Content-Type', 'application/json');
xhr.onload = function () {
console.log('[ALORAA GW] XHR', url, 'status:', xhr.status, xhr.responseText.slice(0, 120));
if (xhr.status >= 200 && xhr.status < 300) {
if (onDone) onDone();
} else {
if (onFail) onFail(xhr.status, xhr.responseText);
}
};
xhr.onerror = function () {
console.warn('[ALORAA GW] XHR onerror', url);
if (onFail) onFail(0, '');
};
console.log('[ALORAA GW] XHR sending to', url, JSON.stringify(body).slice(0, 120));
xhr.send(JSON.stringify(body));
} catch (e) { if (onFail) onFail(-1, String(e)); }
}
function injectBadgesAndHideGw(wrappedTitles, gwItemKeys, gwItemQtys, productQtys) {
try {
try {
var staleBadges = document.querySelectorAll('[data-gw-badge-wrap]');
for (var b = 0; b < staleBadges.length; b++) {
if (staleBadges[b].parentNode) staleBadges[b].parentNode.removeChild(staleBadges[b]);
}
} catch (cleanErr) {}
var titleArr = [];
wrappedTitles.forEach(function (t) { titleArr.push(t.trim()); });
if (!titleArr.length) return;
var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
var node;
var seen = [];
while ((node = walker.nextNode())) {
try {
var nodeText = (node.textContent || '').trim();
if (!nodeText || nodeText.length < 4) continue;
var el = node.parentElement;
if (!el) continue;
if (!isInCartContext(el)) continue;
var row = nearestRow(el);
if (isGwRow(row)) continue;
var matchedTitle = null;
for (var i = 0; i < titleArr.length; i++) {
if (titleMatches(nodeText, titleArr[i])) { matchedTitle = titleArr[i]; break; }
}
if (!matchedTitle) continue;
var alreadySeen = false;
for (var s = 0; s < seen.length; s++) { if (seen[s] === el) { alreadySeen = true; break; } }
if (alreadySeen) continue;
seen.push(el);
if (row && row.querySelector('.' + BADGE_CLS)) continue;
var next = el.nextElementSibling;
if (next && next.querySelector && next.querySelector('.' + BADGE_CLS)) continue;
var gwKeysForProduct = [];
Object.keys(gwItemKeys).forEach(function (k) {
if (k === matchedTitle.toLowerCase() || titleMatches(k, matchedTitle)) {
gwKeysForProduct.push(gwItemKeys[k]);
}
});
var gwKey = gwKeysForProduct.length ? gwKeysForProduct[0] : null;
var badge = document.createElement('span');
badge.className = BADGE_CLS;
var badgeText = document.createElement('span');
var prodQty = productQtys[matchedTitle];
if (prodQty === undefined) {
Object.keys(productQtys).forEach(function (k) {
if (prodQty === undefined && titleMatches(k, matchedTitle)) prodQty = productQtys[k];
});
}
prodQty = prodQty || 1;
var gwQty = 0;
Object.keys(gwItemQtys).forEach(function (k) {
if (k === matchedTitle.toLowerCase() || titleMatches(k, matchedTitle)) gwQty += gwItemQtys[k];
});
gwQty = gwQty || 1;
badgeText.textContent = (gwQty < prodQty)
? '🎁 ' + gwQty + ' of ' + prodQty + ' gift wrapped'
: '🎁 Gift wrapped';
badge.appendChild(badgeText);
if (gwKeysForProduct.length) {
if (gwQty < prodQty) {
var wrapAllSep = document.createElement('span');
wrapAllSep.style.cssText = 'margin:0 2px;color:#b8a89a;';
wrapAllSep.textContent = '·';
badge.appendChild(wrapAllSep);
var wrapAllBtn = document.createElement('button');
wrapAllBtn.textContent = 'Wrap all';
wrapAllBtn.style.cssText = 'background:none;border:none;padding:0;font-size:11px;color:#8b6a4f;cursor:pointer;text-decoration:underline;font-weight:400;';
(function (primaryKey, extraKeys, targetQty, btn) {
btn.addEventListener('mousedown', function (e) {
e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
if (btn.disabled) return;
btn.textContent = 'Adding...';
btn.disabled = true;
var updates = {};
updates[primaryKey] = targetQty;
extraKeys.forEach(function (k) { updates[k] = 0; });
xhrPost('/cart/update.js', { updates: updates }, function () {
scheduleRun(150);
}, function () {
btn.disabled = false;
btn.textContent = 'Wrap all';
});
});
})(gwKeysForProduct[0], gwKeysForProduct.slice(1), prodQty, wrapAllBtn);
badge.appendChild(wrapAllBtn);
}
var sep = document.createElement('span');
sep.style.cssText = 'margin:0 2px;color:#b8a89a;';
sep.textContent = '·';
badge.appendChild(sep);
var removeBtn = document.createElement('button');
removeBtn.textContent = 'Remove';
removeBtn.style.cssText = 'background:none;border:none;padding:0;font-size:11px;color:#8b6a4f;cursor:pointer;text-decoration:underline;font-weight:400;';
(function (keys, btn) {
btn.addEventListener('mousedown', function (e) {
e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
if (btn.disabled) return;
btn.textContent = 'Removing...';
btn.disabled = true;
var updates = {};
keys.forEach(function (k) { updates[k] = 0; });
xhrPost('/cart/update.js', { updates: updates }, function () {
scheduleRun(150);
}, function() { btn.disabled = false; btn.textContent = 'Remove'; });
});
btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); });
})(gwKeysForProduct, removeBtn);
badge.appendChild(removeBtn);
}
var wrapper = document.createElement('div');
wrapper.setAttribute('data-gw-badge-wrap', '1');
wrapper.style.cssText = 'display:block;margin:4px 0 2px;';
wrapper.appendChild(badge);
el.insertAdjacentElement('afterend', wrapper);
} catch (innerErr) {  }
}
} catch (e) {}
}
function injectGwOffer(wrappedTitles, allProducts) {
try {
try {
var staleOffers = document.querySelectorAll('.' + OFFER_CLS);
for (var o = 0; o < staleOffers.length; o++) {
if (staleOffers[o].parentNode) staleOffers[o].parentNode.removeChild(staleOffers[o]);
}
} catch (cleanErr) {}
if (!allProducts.length) return;
var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
var node;
while ((node = walker.nextNode())) {
try {
var nodeText = (node.textContent || '').trim();
if (!nodeText || nodeText.length < 4) continue;
if (!isInCartContext(node.parentElement)) continue;
var matchedProduct = null;
for (var i = 0; i < allProducts.length; i++) {
if (titleMatches(nodeText, allProducts[i].title)) { matchedProduct = allProducts[i]; break; }
}
if (!matchedProduct) continue;
var alreadyWrapped = false;
wrappedTitles.forEach(function (t) {
if (titleMatches(matchedProduct.title, t)) alreadyWrapped = true;
});
if (alreadyWrapped) continue;
var el = node.parentElement;
if (!el) continue;
var row = nearestRow(el);
if (isGwRow(row)) continue;
if (row && row.querySelector('.' + OFFER_CLS)) continue;
var offer = document.createElement('div');
offer.className = OFFER_CLS;
offer.innerHTML =
'<img src="' + GW_IMAGE_URL + '" alt="Gift wrap" style="width:44px;height:44px;object-fit:cover;border-radius:4px;flex-shrink:0;">' +
'<span class="' + OFFER_CLS + '__text">🎁 Add gift wrapping? <strong>+£5</strong></span>' +
'<button class="' + OFFER_CLS + '__btn" type="button">Add</button>';
console.log('[ALORAA GW] offer injected for:', matchedProduct.title);
var btn = offer.querySelector('.' + OFFER_CLS + '__btn');
(function (capturedTitle, offerEl, addBtn) {
addBtn.addEventListener('mousedown', function (e) {
console.log('[ALORAA GW] btn mousedown fired, title:', capturedTitle);
e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
if (addBtn.disabled) return;
addBtn.disabled = true;
addBtn.textContent = 'Adding...';
xhrPost('/cart/add.js', {
items: [{ id: GW_VARIANT_ID, quantity: 1, properties: { 'Wrapping for': capturedTitle } }]
}, function () {
try {
var liveOffer = document.querySelector('.' + OFFER_CLS);
if (liveOffer && liveOffer.parentNode) liveOffer.parentNode.removeChild(liveOffer);
} catch (_) {}
scheduleRun(0);
}, function (status) {
addBtn.disabled = false;
addBtn.textContent = 'Add';
console.warn('[ALORAA GW] cart/add.js failed:', status);
});
});
addBtn.addEventListener('click', function (e) {
e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
});
})(matchedProduct.title, offer, btn);
var injectAfter = row || el;
injectAfter.insertAdjacentElement('afterend', offer);
try {
var anc = offer.parentElement;
while (anc && anc !== document.body) {
if (anc.tagName === 'A' && anc.parentNode) {
anc.parentNode.insertBefore(offer, anc.nextSibling);
break;
}
anc = anc.parentElement;
}
} catch (ae) {}
} catch (innerErr) {  }
}
} catch (e) {}
}
function findGwItemRow(el) {
try {
var c = el.closest(
'li, [class*="cart-item"], [class*="cartItem"], [class*="cart_item"], ' +
'[class*="line-item"], [class*="lineItem"], [class*="item--"], ' +
'[class*="CartItem"], [class*="product-item"]'
);
if (c && c !== document.body && isInCartContext(c)) return c;
} catch (e) {}
var cur = el;
for (var i = 0; i < 18; i++) {
if (!cur || cur === document.body) break;
if (cur.querySelector && cur.querySelector('img') &&
(cur.textContent || '').indexOf('£') !== -1 &&
(cur.textContent || '').indexOf('Gift Wrapping') !== -1) {
var par = cur.parentElement;
var parLen = par ? (par.textContent || '').length : 0;
var curLen = (cur.textContent || '').length;
if (!par || parLen > curLen * 1.25) return cur;
}
cur = cur.parentElement;
}
return null;
}
function findProductRow(wrappingForTitle) {
var rw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
var rn;
while ((rn = rw.nextNode())) {
var rt = (rn.textContent || '').trim();
if (!titleMatches(rt, wrappingForTitle)) continue;
var rel = rn.parentElement;
if (!rel || !isInCartContext(rel)) continue;
if (isGwRow(rel)) continue;
try {
var rc = rel.closest(
'li, [class*="cart-item"], [class*="cartItem"], [class*="cart_item"], ' +
'[class*="line-item"], [class*="lineItem"], [class*="item--"], ' +
'[class*="CartItem"], [class*="product-item"]'
);
if (rc && rc !== document.body && isInCartContext(rc) && !isGwRow(rc)) return rc;
} catch (e) {}
var cur = rel;
for (var i = 0; i < 15; i++) {
if (!cur || cur === document.body) break;
if (cur.querySelector && cur.querySelector('img') &&
(cur.textContent || '').indexOf('£') !== -1) {
var par = cur.parentElement;
var parLen = par ? (par.textContent || '').length : 0;
var curLen = (cur.textContent || '').length;
if (!par || parLen > curLen * 1.25) {
if (!isGwRow(cur)) return cur;
}
}
cur = cur.parentElement;
}
}
return null;
}
function styleGiftWrapRows() {
try {
try {
document.querySelectorAll('[data-gw-inline]').forEach(function(el) {
if (el.parentNode) el.parentNode.removeChild(el);
});
} catch(ce) {}
var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
var node;
var processedRows = [];
while ((node = walker.nextNode())) {
try {
if ((node.textContent || '').trim() !== 'Gift Wrapping') continue;
var el = node.parentElement;
if (!el || !isInCartContext(el)) continue;
var gwRow = findGwItemRow(el);
if (!gwRow || gwRow === document.body) continue;
var dup = false;
for (var j = 0; j < processedRows.length; j++) { if (processedRows[j] === gwRow) { dup = true; break; } }
if (dup) continue;
processedRows.push(gwRow);
gwRow.style.setProperty('display', 'none', 'important');
var rowText = gwRow.textContent || '';
var priceMatch = rowText.match(/£[\d.,]+/);
var price = priceMatch ? priceMatch[0] : '£5.00';
var wrappingFor = null;
var wfIdx = rowText.toLowerCase().indexOf('wrapping for:');
if (wfIdx !== -1) {
var raw = rowText.slice(wfIdx + 'wrapping for:'.length).trim();
raw = raw.replace(/\s*£[\d.,]+.*$/, '').trim().split('\n')[0].trim();
if (raw.length > 2) wrappingFor = raw;
}
// Resolve cart key at injection time so Remove always has it
var gwCartKey = null;
if (wrappingFor) {
gwCartKey = _lastGwItemKeys[wrappingFor.toLowerCase()];
if (!gwCartKey) {
Object.keys(_lastGwItemKeys).forEach(function(k) {
if (!gwCartKey && titleMatches(k, wrappingFor)) gwCartKey = _lastGwItemKeys[k];
});
}
}
if (!gwCartKey) {
var _allGwVals = Object.keys(_lastGwItemKeys).map(function(k) { return _lastGwItemKeys[k]; });
gwCartKey = _allGwVals[processedRows.length - 1] || _allGwVals[0] || null;
}
var inline = document.createElement('div');
inline.setAttribute('data-gw-inline', '1');
var inner = document.createElement('span');
inner.textContent = '🎁 Gift Wrapping';
inner.style.cssText = 'flex:1;font-weight:500;';
var priceEl = document.createElement('span');
priceEl.textContent = price;
priceEl.style.cssText = 'color:#888;margin-right:4px;';
var removeBtn = document.createElement('button');
removeBtn.textContent = 'Remove';
removeBtn.style.cssText = 'background:none;border:none;padding:0;font-size:11px;color:#8b6a4f;cursor:pointer;text-decoration:underline;font-weight:400;';
removeBtn.setAttribute('type', 'button');
(function(cartKey, btn) {
btn.addEventListener('mousedown', function(e) {
e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
if (btn.disabled) return;
btn.textContent = 'Removing…'; btn.disabled = true;
function doRemove(key) {
if (!key) { btn.disabled = false; btn.textContent = 'Remove'; return; }
var updates = {}; updates[key] = 0;
xhrPost('/cart/update.js', { updates: updates }, function() { scheduleRun(150); }, function() { btn.disabled = false; btn.textContent = 'Remove'; });
}
if (cartKey) {
doRemove(cartKey);
} else {
var x = new XMLHttpRequest();
x.open('GET', '/cart.js', true);
x.onload = function() {
var key = null;
try {
JSON.parse(x.responseText).items.forEach(function(item) {
if (!key && String(item.variant_id) === String(GW_VARIANT_ID)) key = item.key;
});
} catch(ex) {}
doRemove(key);
};
x.onerror = function() { btn.disabled = false; btn.textContent = 'Remove'; };
x.send();
}
});
btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); });
})(gwCartKey, removeBtn);
inline.appendChild(inner);
inline.appendChild(priceEl);
inline.appendChild(removeBtn);
var productRow = wrappingFor ? findProductRow(wrappingFor) : null;
var anchor = (productRow && productRow.parentNode) ? productRow : null;
if (!anchor && gwRow.previousElementSibling && !isGwRow(gwRow.previousElementSibling)) {
anchor = gwRow.previousElementSibling;
}
if (anchor && anchor.parentNode) {
var sib = anchor.nextElementSibling;
while (sib && sib.getAttribute && sib.getAttribute('data-gw-inline')) {
anchor = sib; sib = sib.nextElementSibling;
}
anchor.parentNode.insertBefore(inline, anchor.nextSibling);
} else if (gwRow.parentNode) {
gwRow.parentNode.insertBefore(inline, gwRow);
}
} catch (innerErr) {}
}
} catch (e) {}
}
function fixNoteLabel() {
try {
var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
var node;
while ((node = walker.nextNode())) {
var t = node.textContent.trim();
if (t !== 'Add a note to your order' && t !== 'Add a note') continue;
var el = node.parentElement;
if (!el || el.getAttribute('data-gw-note-fixed')) continue;
var frag = document.createDocumentFragment();
var emojiSpan = document.createElement('span');
emojiSpan.style.cssText = 'font-size:18px;margin-right:6px;vertical-align:middle;';
emojiSpan.textContent = '💌';
frag.appendChild(emojiSpan);
frag.appendChild(document.createTextNode('Add a gift note to your order'));
node.parentNode.replaceChild(frag, node);
el.style.fontWeight = '600';
el.style.fontSize = '14px';
el.style.color = '#1a1a1a';
el.setAttribute('data-gw-note-fixed', '1');
}
} catch (e) {}
}
function syncQtys(cartItems) {
var productQtys = {};
var gwItems = {};
cartItems.forEach(function (item) {
if (String(item.variant_id) === String(GN_VARIANT_ID)) return;
var wrappingFor = item.properties && item.properties['Wrapping for'];
if (wrappingFor) {
gwItems[item.key] = { title: wrappingFor.trim(), qty: item.quantity };
} else {
var title = (item.title || item.product_title || '').trim();
if (title) productQtys[title] = (productQtys[title] || 0) + item.quantity;
}
});
var updates = {};
var seenGwByProduct = [];
Object.keys(gwItems).forEach(function (dupKey) {
var gw = gwItems[dupKey];
var matched = null;
for (var di = 0; di < seenGwByProduct.length; di++) {
var s = seenGwByProduct[di];
if (titleMatches(s.matchKey, gw.title) || titleMatches(gw.title, s.matchKey)) {
matched = s; break;
}
}
if (matched) {
if (gw.qty > matched.qty) {
updates[matched.key] = 0;
matched.key = dupKey; matched.qty = gw.qty; matched.matchKey = gw.title;
} else {
updates[dupKey] = 0;
}
} else {
seenGwByProduct.push({ matchKey: gw.title, key: dupKey, qty: gw.qty });
}
});
Object.keys(gwItems).forEach(function (key) {
var gw = gwItems[key];
var matchedQty = productQtys[gw.title];
if (matchedQty === undefined) {
Object.keys(productQtys).forEach(function (k) {
if (matchedQty === undefined && titleMatches(k, gw.title)) matchedQty = productQtys[k];
});
}
if (matchedQty === undefined) {
updates[key] = 0;
} else if (matchedQty < gw.qty) {
updates[key] = matchedQty;
}
});
if (!Object.keys(updates).length) return;
xhrPost('/cart/update.js', { updates: updates }, function () {
scheduleRun(150);
});
}
var _lastCartNote = null;
function syncGiftNoteItem(cartNote, cartItems) {
var gnItem = null;
cartItems.forEach(function (item) {
if (String(item.variant_id) === String(GN_VARIANT_ID)) gnItem = item;
});
if (cartNote && !gnItem) {
xhrPost('/cart/add.js', {
items: [{ id: GN_VARIANT_ID, quantity: 1, properties: { 'Gift note': cartNote } }]
}, function () { scheduleRun(300); });
} else if (!cartNote && gnItem) {
var upd = {}; upd[gnItem.key] = 0;
xhrPost('/cart/update.js', { updates: upd }, function () { scheduleRun(300); });
} else if (cartNote && gnItem) {
var existing = gnItem.properties && gnItem.properties['Gift note'];
if (existing !== cartNote) {
xhrPost('/cart/change.js', {
id: gnItem.key, quantity: 1, properties: { 'Gift note': cartNote }
}, function () { scheduleRun(300); });
}
}
}
function hideGiftNoteRows() {
try {
var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
var node;
while ((node = walker.nextNode())) {
if ((node.textContent || '').trim() !== 'Gift Note') continue;
var el = node.parentElement;
if (!el || !isInCartContext(el)) continue;
var row = nearestRow(el);
if (!row || row === document.body) continue;
row.style.setProperty('display', 'none', 'important');
}
} catch (e) {}
}
var _running = false;
var _runTimer = null;
function scheduleRun(delay) {
clearTimeout(_runTimer);
_runTimer = setTimeout(run, delay || 300);
}
function run() {
if (_running) return;
_running = true;
try {
var xhr = new XMLHttpRequest();
xhr.open('GET', '/cart.js', true);
xhr.onload = function () {
try {
var cart = JSON.parse(xhr.responseText);
var wrapped      = new Set();
var gwItemKeys   = {};
var gwItemQtys   = {};
var productQtys  = {};
var allProducts  = [];
var seenTitles   = {};
(cart.items || []).forEach(function (item) {
if (String(item.variant_id) === String(GN_VARIANT_ID)) return;
var wrappingFor = item.properties && item.properties['Wrapping for'];
if (wrappingFor) {
var t = wrappingFor.trim();
wrapped.add(t);
gwItemKeys[t.toLowerCase()] = item.key;
gwItemQtys[t.toLowerCase()] = (gwItemQtys[t.toLowerCase()] || 0) + item.quantity;
} else {
var title = (item.title || item.product_title || '').trim();
if (title) productQtys[title] = (productQtys[title] || 0) + item.quantity;
if (title && !seenTitles[title]) {
seenTitles[title] = true;
allProducts.push({ title: title });
}
}
});
var cartNote = (cart.note || '').trim();
if (cartNote !== _lastCartNote) {
_lastCartNote = cartNote;
syncGiftNoteItem(cartNote, cart.items || []);
}
syncQtys(cart.items || []);
_lastGwItemKeys = gwItemKeys;
styleGiftWrapRows();
hideGiftNoteRows();
injectBadgesAndHideGw(wrapped, gwItemKeys, gwItemQtys, productQtys);
injectGwOffer(wrapped, allProducts);
fixNoteLabel();
} catch (e) {}
_running = false;
};
xhr.onerror = function () { _running = false; };
xhr.send();
} catch (e) { _running = false; }
}
var _gwObserving = false;
try {
var _gwObserver = new MutationObserver(function (mutations) {
if (_gwObserving) return;
for (var mi = 0; mi < mutations.length; mi++) {
var added = mutations[mi].addedNodes;
for (var ni = 0; ni < added.length; ni++) {
var n = added[ni];
if (!n || n.nodeType !== 1) continue;
if (n.getAttribute('data-gw-pos')) continue;
if (n.querySelector && n.querySelector('[data-gw-pos]')) continue;
if ((n.textContent || '').indexOf('Gift Wrapping') !== -1) {
_gwObserving = true;
setTimeout(function () {
try { styleGiftWrapRows(); } catch (e) {}
_gwObserving = false;
}, 0);
return;
}
}
}
});
_gwObserver.observe(document.body, { childList: true, subtree: true });
} catch (e) {}
setInterval(function () {
if (!_running) run();
}, 500);
try {
document.addEventListener('cart:refresh', function () { scheduleRun(150); });
window.addEventListener('cart:refresh', function () { scheduleRun(150); });
} catch (e) {}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { run(); setTimeout(run, 1500); });
} else {
run();
setTimeout(run, 1500);
}
// ALORAA: Notify-me flash guard — hides BIS section during ATC loading
// Uses document-level delegation + polling so it survives Shopify section re-renders
(function() {
  var _bisInterval = null;

  function hideBIS() {
    var bis = document.getElementById('alo-bis-wrap');
    if (bis) bis.style.setProperty('display', 'none', 'important');
  }

  function isATCLoading() {
    var btn = document.querySelector('.product-form__submit');
    return !!(btn && (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading')));
  }

  function startGuard() {
    hideBIS();
    clearInterval(_bisInterval);
    var t0 = Date.now();
    _bisInterval = setInterval(function() {
      if (Date.now() - t0 > 8000) { clearInterval(_bisInterval); _bisInterval = null; return; }
      if (isATCLoading()) { hideBIS(); } else { clearInterval(_bisInterval); _bisInterval = null; }
    }, 16);
  }

  // Document-level capture: fires before any other handler, survives DOM replacement
  document.addEventListener('mousedown', function(e) {
    var el = e.target;
    while (el && el !== document.body) {
      if (el.classList && el.classList.contains('product-form__submit')) { startGuard(); return; }
      el = el.parentElement;
    }
  }, true);

  // Subtree observer: catches aria-disabled changes on any matching button, even after re-render
  new MutationObserver(function(muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.classList && t.classList.contains('product-form__submit') && isATCLoading()) {
        startGuard(); break;
      }
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['aria-disabled', 'class'], subtree: true });
})();

})();